<template>
    <div
        class="ticker"
        role="region"
        aria-label="Bolos à tua medida, feitos à mão em Pitões das Júnias">
        <div class="ticker__track">
            <!-- Primeira iteração do conteúdo (Original) -->
            <div class="ticker__content">
                <template v-for="(phrase, index) in repeatedPhrases" :key="`original-${index}`">
                    <p class="ticker__text">{{ phrase }}</p>
                    <img class="ticker__separator" src="@/assets/images/cake-logo-white.png" alt="" aria-hidden="true" />
                </template>
            </div>
            
            <!-- Segunda iteração (Cópia para criar a ilusão do loop infinito) -->
            <div class="ticker__content" aria-hidden="true">
                <template v-for="(phrase, index) in repeatedPhrases" :key="`copy-${index}`">
                    <p class="ticker__text">{{ phrase }}</p>
                    <img class="ticker__separator" src="@/assets/images/cake-logo-white.png" alt="" aria-hidden="true" />
                </template>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    // As frases originais separadas numa lista (array)
    const basePhrases = [
        'Bolos à tua medida',
        'Feitos à mão em Pitões das Júnias',
        'Para os momentos que ficam'
    ];

    // Cria a repetição (tal como o teu .repeat(4)) achatando o array
    const repeatedPhrases = Array(4).fill(basePhrases).flat();
</script>

<style scoped>
    .ticker {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 60;
        display: flex;
        align-items: center;
        width: 100%;
        height: var(--ticker-h, 36px);
        overflow: hidden;
        background: #6e2432;
        color: #fbf6e8;
    }

    .ticker__track {
        display: flex;
        width: max-content;
        /* Aumentei de 120s para 240s para demorar mais. Podes ajustar ao teu gosto. */
        animation: ticker-marquee 240s linear infinite;
    }

    /* Agrupador flex para alinhar textos e imagens lado a lado */
    .ticker__content {
        display: flex;
        align-items: center;
    }

    .ticker__text {
        margin: 0;
        font-size: 0.78rem;
        letter-spacing: 0.14em;
        text-transform: uppercase;
        white-space: nowrap;
        color: #fbf6e8;
    }

    /* Estilos para o ícone (substituto do " · ") */
    .ticker__separator {
        height: 16px; /* Ajusta este valor dependendo do tamanho da tua imagem */
        width: auto;
        margin: 0 32px; /* Margem lateral para dar o espaçamento entre a imagem e as frases */
        object-fit: contain;
        color: #fbf6e8;
    }

    @keyframes ticker-marquee {
        from {
            transform: translateX(0);
        }
        to {
            transform: translateX(-50%);
        }
    }

    @media (prefers-reduced-motion: reduce) {
        .ticker__track {
            animation: none;
        }
    }
</style>